
import Base from '../components/Base/Base';
import Hero from '../components/Home/Hero';
import Map from "../components/Home/Map";




const Home = () => {
    return(
        <Base>
       <Hero />
        <Map />
        </Base>
    )
}

export default Home;